import { Injectable, inject } from "@angular/core";
import { productStringFromApplicationType } from "@app/views-interfaces";
import { AuthService } from "../auth/auth.service";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";

export interface IUserAvailableDocument {
    dashboardId: string;
    dashboardCardIds: string[];
}

type UserAvailableDocumentsCache = Record<string, Record<number, IUserAvailableDocument[]>>;

@Injectable({
    providedIn: "root",
})
export class IfirmTaxCardsService {
    private readonly authService = inject(AuthService);
    private readonly iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    cachedUserAvailableDocuments: UserAvailableDocumentsCache = {};

    constructor() {}

    async deleteCards(dashboardId: string, cards: string[]) {
        await this.iframeMessagesService.postMessageResp("deleteCards", { dashboardId, cards }, "cardsDeleted");
    }

    async getUserAvailableDocuments(userId: string, applicationType: number, taxYear: number): Promise<IUserAvailableDocument[] | undefined> {
        const productType = productStringFromApplicationType(applicationType);
        if (!this.cachedUserAvailableDocuments[productType]?.[taxYear]) {
            // TODO If this change for DASH-16982 is acceptable and does not cause issues with iFirm Taxprep,
            // remove commented code in this class.
            // if (!this.getFromLocalStorage(userId, productType, taxYear)) {
            try {
                const result = await this.iframeMessagesService.postMessageResp(
                    "getAvailableDocuments",
                    { productType, taxYear },
                    "gotiFirmTaxAvailableDocuments",
                );
                if (!this.cachedUserAvailableDocuments[productType]) {
                    this.cachedUserAvailableDocuments[productType] = {};
                }
                if (result.status === "success") {
                    this.cachedUserAvailableDocuments[productType][taxYear] = result.response as IUserAvailableDocument[];
                    // this.setOnLocalStorage(
                    //     this.authService.currentUser.sub,
                    //     productType,
                    //     result.taxYear,
                    //     this.cachedUserAvailableDocuments[productType][result.taxYear],
                    // );
                } else {
                    this.responseErrorHandlerService.showPopup({
                        typeLayout: "ERROR",
                        messageCode: "defaultError",
                    });
                }
            } catch {
                this.responseErrorHandlerService.showPopup({
                    typeLayout: "ERROR",
                    messageCode: "defaultError",
                });
            }
            // }
        }
        return this.cachedUserAvailableDocuments[productType]?.[taxYear];
    }

    // getFromLocalStorage(userId: string, productType: string, taxYear: number): IUserAvailableDocument[] | undefined {
    //     const expiration = localStorage.getItem("UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear + "_expiration");
    //     if (expiration && parseInt(expiration) > Date.now()) {
    //         if (!this.cachedUserAvailableDocuments[productType]) {
    //             this.cachedUserAvailableDocuments[productType] = {};
    //         }
    //         this.cachedUserAvailableDocuments[productType][taxYear] = JSON.parse(
    //             localStorage.getItem("UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear),
    //         ) as IUserAvailableDocument[];
    //         return this.cachedUserAvailableDocuments[productType][taxYear];
    //     } else {
    //         localStorage.removeItem("UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear + "_expiration");
    //         localStorage.removeItem("UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear);
    //     }
    // }

    // setOnLocalStorage(userId: string, productType: string, taxYear: number, response: IUserAvailableDocument[]) {
    //     LocalStorageService.setItem("UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear, JSON.stringify(response));
    //     LocalStorageService.setItem(
    //         "UserAvailableDocuments_" + userId + "_" + productType + "_" + taxYear + "_expiration",
    //         String(Date.now() + 60 * 60 * 1000),
    //     );
    // }
}
